// extracted by mini-css-extract-plugin
var _1 = "Item_email__X6kGb";
var _2 = "Item_menuItem__lxbIZ";
var _3 = "Item_menuItemText__qH8PH";
var _4 = "Item_name__n8PP1";
var _5 = "Item_username__-zZNk";
export { _1 as "email", _2 as "menuItem", _3 as "menuItemText", _4 as "name", _5 as "username" }
